import { ContentReportCategory } from "Infrastructure/Api/Api";
import type { CodeListItem } from "Models/ICodeListDto";
import {
  Resources,
  type ResourceDictionary,
  useResource,
} from "Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";

const R = Resources.Support.ContentReport.Categories;

const CATEGORY_RESOURCES: Record<
  ContentReportCategory,
  ObjPathProxy<ResourceDictionary, string>
> = {
  [ContentReportCategory.ChildSexualAbuse]: R.ChildSexualAbuse,
  [ContentReportCategory.ThreatsOrViolence]: R.ThreatsOrViolence,
  [ContentReportCategory.HateSpeech]: R.HateSpeech,
  [ContentReportCategory.FraudOrScam]: R.FraudOrScam,
  [ContentReportCategory.Impersonation]: R.Impersonation,
  [ContentReportCategory.PersonalDataOrPrivacy]: R.PersonalDataOrPrivacy,
  [ContentReportCategory.IntellectualProperty]: R.IntellectualProperty,
  [ContentReportCategory.OtherIllegal]: R.OtherIllegal,
  [ContentReportCategory.HarassmentOrBullying]: R.HarassmentOrBullying,
  [ContentReportCategory.SpamOrUnwantedContact]: R.SpamOrUnwantedContact,
  [ContentReportCategory.OtherTermsViolation]: R.OtherTermsViolation,
};

export const useContentReportCategoryCodeList = (): Array<
  CodeListItem<ContentReportCategory>
> => {
  const { t } = useResource();

  return Object.values(ContentReportCategory).map((category) => ({
    code: category,
    name: t(CATEGORY_RESOURCES[category]),
  }));
};
